export default __webpack_public_path__ + "static/media/new-logo.136a3533.png";